import { render, staticRenderFns } from "./InhouseProfessionals.vue?vue&type=template&id=7c1a4814&"
import script from "./InhouseProfessionals.vue?vue&type=script&lang=ts&"
export * from "./InhouseProfessionals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports